<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Organisation Bearbeiten</h5>
          <hr>

          <!-- Abkürzung-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Abkürzung</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.shortname"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.shortname"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.shortname"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Name-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Name</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.name"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.name"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.name"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Name2-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Name 2</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.name2"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.name2"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.name2"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Adresse-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Adresse </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.address"
                label="Adresse"
              />
            </div>
          </b-row>

          <!-- Postfach-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Postfach </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.poBox"
                label="Postfach"
              />
            </div>
          </b-row>

          <!-- PLZ/ Ort-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> PLZ / Ort </label>
            <div class="col-2 pl-1">
              <v-text-field
                v-model="organisationsObject.zipCode"
                label="PLZ"
              />
            </div>
            <div class="col-5 pl-1">
              <v-text-field
                v-model="organisationsObject.city"
                label="Ort"
              />
            </div>
          </b-row>

          <!-- Telefon-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Telefon </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.phone"
                label="Telefon"
              />
            </div>
          </b-row>

          <!-- Email-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Email </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="organisationsObject.email"
                label="Email"
              />
            </div>
          </b-row>

          <!-- Region/Sektion-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Region/Sektion</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.regionSection"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.regionSection"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.regionSection"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>

          <!-- Homepage-->
          <b-row class="mt-2">
            <v-expansion-panel value="[true]">
              <v-expansion-panel-content>
                <template v-slot:header>
                  <h5>Homepage</h5>
                </template>
                <div class="col-7 pl-4">
                  <v-text-field
                    v-model="organisationContentsDe.homepage"
                    label="Deutsch"
                  />
                  <v-text-field
                    v-model="organisationContentsFr.homepage"
                    label="Französisch"
                  />
                  <v-text-field
                    v-model="organisationContentsIt.homepage"
                    label="Italienisch"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </b-row>
        </v-container>
      </v-card>

      <v-btn
        :disabled="
          !organisationContentsDe.name ||
            !organisationContentsFr.name ||
            !organisationContentsFr.name
        "
        class="btn-left"
        color="success"
        raised
        title="Organisation Speichern"
        @click="saveEdit"
      >
        <i class="fas fa-save mr-3" /> Speichern
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelEdit"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  GetOrganisationWithId,
  PutOrganisation,
} from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      organisationsObject: {
        id: 0,
        address: "",
        poBox: "",
        zipCode: "",
        city: "",
        phone: "",
        email: "",
        organisationContents: [],
      },
      organisationContentsDe: {
        id: 0,
        organisationId: 0,
        language: "de-CH",
        shortname: "",
        name: "",
        name2: "",
        homepage: "",
        regionSection: "",
      },
      organisationContentsFr: {
        id: 0,
        organisationId: 0,
        language: "fr-CH",
        shortname: "",
        name: "",
        name2: "",
        homepage: "",
        regionSection: "",
      },
      organisationContentsIt: {
        id: 0,
        organisationId: 0,
        language: "it-CH",
        shortname: "",
        name: "",
        name2: "",
        homepage: "",
        regionSection: "",
      },
      errorObject: null,
    };
  },
  created() {
    if (this.$route.query.organisationNr) {
      this.getOrgantisation(this.$route.query.organisationNr);
    }
  },
  methods: {
    routePage() {
      this.$router.push({
        path: "/organisation",
      });
    },
    cancelEdit() {
      this.routePage();
    },
    saveEdit() {
      this.isLoading = true;

      this.organisationsObject.organisationContents = [];
      this.organisationsObject.organisationContents.push(
        this.organisationContentsDe,
      );
      this.organisationsObject.organisationContents.push(
        this.organisationContentsFr,
      );
      this.organisationsObject.organisationContents.push(
        this.organisationContentsIt,
      );
      PutOrganisation(
        this.organisationsObject.id,
        this.organisationsObject,
        () => {
          this.isLoading = false;
          this.routePage();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    getOrgantisation(organisationId) {
      GetOrganisationWithId(
        organisationId,
        (response) => {
          this.organisationsObject = response;
          var contents = response.organisationContents;
          var contentsDe = contents.filter((x) => x.language === "de-CH");
          if (contentsDe.length > 0) {
            this.organisationContentsDe = contentsDe[0];
          }
          var contentsFr = contents.filter((x) => x.language === "fr-CH");
          if (contentsFr.length > 0) {
            this.organisationContentsFr = contentsFr[0];
          }
          var contentsIt = contents.filter((x) => x.language === "it-CH");
          if (contentsIt.length > 0) {
            this.organisationContentsIt = contentsIt[0];
          }

          this.isLoading = false;
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.card-body {
  margin: 20px;
}

.btn-left {
  margin-left: 20px;
}
</style>
